// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ocultar scrollbars duplicados - el scroll está en app-content-container */
.cards-container::-webkit-scrollbar,
.filter-bar-container-mobile::-webkit-scrollbar,
.filter-bar-container-desktop::-webkit-scrollbar,
.scrollable-container::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
}

.cards-container,
.filter-bar-container-mobile,
.filter-bar-container-desktop {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE and Edge */
}

/* Estilos específicos para el componente app-cards-real-estate */
:host {
  /* Oportunidades es el único hijo del navbar-router-container (no tiene
     app-navbar-user). Debe ocupar TODO su alto (calc(100vh-30px)); si el
     content-container se quedara en calc(100vh-60px), faltarían 30px abajo
     y el fondo del navbar-router-container asomaría (franja inferior). */
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow-x: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

/* El content-container llena el alto disponible y conserva su scroll interno. */
:host ::ng-deep app-content-container {
  flex: 1 1 0 !important;
  min-height: 0 !important;
}

:host ::ng-deep app-content-container > .content-container {
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
}

/* Romper min-width:auto en TODA la cadena interna */
.cards-container,
.cards-container .row,
.cards-container .col-lg-4,
.cards-container .col-md-6,
.cards-container .col-12,
.filter-bar-container-desktop,
.filter-bar-container-mobile,
.desktop-filter-bar,
.desktop-filter-bar .d-flex.w-100 {
  min-width: 0 !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* Asegurar que todos los contenedores del componente usen todo el ancho */
:host > * {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* Remove the grey shadowing (separation) between header and content container */
:host ::ng-deep .content-container,
:host ::ng-deep .content-container.variant-white,
:host ::ng-deep app-content-container .content-container {
  box-shadow: none !important;
  border-top: none !important;
}

/* Contenedor de filtros debe usar el ancho disponible sin romper padding */
.filter-bar-container-mobile,
.filter-bar-container-desktop {
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ======================================
   FILTER BAR AND CARD CONTAINER FIXES
   ====================================== */

/* Base filter container styles */
.filter-bar-container-mobile {
  width: 100%;
  position: relative;
  margin-bottom: 2rem !important; /* Espacio entre filtros y cards */
}

.filter-bar-container-desktop {
  width: 100%;
  margin-bottom: 2rem !important; /* Espacio entre filtros y cards */
}

/* Improved filter bar mobile */
.filter-bar-mobile {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.75rem;
  z-index: 10;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: none !important; /* Forzar que esté oculto por defecto */
  opacity: 0;
  visibility: hidden;
}

.filter-bar-mobile.show {
  display: block !important; /* Forzar que se muestre cuando tenga la clase show */
  opacity: 1 !important;
  visibility: visible !important;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.filter-bar-mobile.hide {
  transform: translateY(-10%);
  opacity: 0;
  visibility: hidden;
}

/* Filter toggle button */
.toggle-filter-btn {
  margin: 0px 10px;
  background-color: #ff8c00;
  color: #ffffff;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  width: auto;
  display: flex;
  align-items: center;
}

.toggle-filter-btn:hover {
  background-color: #e57a00;
  transform: scale(1.02);
}

/* Barra de filtros */
.filter-bar-mobile,
.desktop-filter-bar {
  margin-bottom: 0.25rem !important;
}

/* Filter inputs and controls */
.filter-bar-mobile input,
.desktop-filter-bar input,
.filter-bar-mobile select,
.desktop-filter-bar select,
.filter-bar-mobile button,
.desktop-filter-bar button,
.filter-bar-mobile .date-picker,
.desktop-filter-bar .desktop-date-picker {
  flex: 1 1 auto;       /* Todos ocupan el mismo espacio disponible */
  min-width: 110px;      /* Puedes ajustar este valor según el espacio que dispongas */
  padding: 0.5rem;       /* Asegura consistencia en el padding */
  border: 2px solid #cccccc; /* Cambiado a gris */
  border-radius: 8px;
  font-size: 0.9rem;
  width: 100% !important;
  height: 2.25rem !important;
  box-sizing: border-box;
}

.filter-bar-mobile .filter-btn {
  flex: 1 1 calc(50% - 10px);
  text-align: center;
}

.filter-buttons {
  display: flex;
  width: 100%;
  gap: 6px;
}

.filter-bar-mobile input[type="text"],
.desktop-filter-bar input[type="text"],
.filter-bar-mobile select,
.desktop-filter-bar select,
.filter-bar-mobile button,
.desktop-filter-bar button {
  flex: 1;
  padding: 0.5rem;
  border: 2px solid #cccccc; /* Cambiado a gris */
  border-radius: 8px;
  font-size: 0.9rem;
  height: 2.25rem; 
  padding: 0.25rem 0.5rem;
}

.filter-bar-mobile select.order-by-dropdown,
.desktop-filter-bar select.order-by-dropdown {
  margin-right: 10px;
}

/* Estado del proyecto y Orden Rentabilidad en gris claro, igual que Buscar por nombre */
.desktop-filter-bar select.status-dropdown,
.desktop-filter-bar select.price-dropdown,
.filter-bar-mobile select.status-dropdown,
.filter-bar-mobile select.price-dropdown {
  color: #6c757d !important;
}

.desktop-filter-bar select.status-dropdown option,
.desktop-filter-bar select.price-dropdown option,
.filter-bar-mobile select.status-dropdown option,
.filter-bar-mobile select.price-dropdown option {
  color: #212529;
}

.filter-bar-mobile button,
.desktop-filter-bar button {
  background-color: #FF8C00;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.filter-bar-mobile button:hover,
.desktop-filter-bar button:hover {
  background-color: #E57A00;
  transform: scale(1.01);
}

.filter-btn,
.reset-button {
  background-color: rgba(255, 140, 0, 0.3) !important; /* Naranja transparente light por defecto */
  color: #ff8c00 !important; /* Texto naranja */
  border: 2px solid rgba(255, 140, 0, 0.5) !important; /* Borde naranja transparente */
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s, color 0.3s, border-color 0.3s, opacity 0.3s;
  width: 100% !important;
  height: 100% !important;
  opacity: 0.7; /* Visible pero light */
}

/* Fila con Resetear filtros + campana + icono perfil (desktop) */
.filter-actions-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

/* ======================================
   NEW UI TOP BAR STYLES (SEARCH & BUTTONS)
   ====================================== */

.desktop-filter-bar .d-flex.w-100 {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important; /* Allow items to naturally pack from left */
  gap: 71px !important; /* Strict 71px gap requested from Figma */
  align-self: stretch !important;
}

.search-container {
  display: flex !important;
  width: auto !important;
  height: 38px !important;
  padding: 10px 16px !important;
  align-items: center !important;
  gap: 18px !important;
  flex: 1 1 auto !important; /* Allow search bar to stretch and fill remaining space */
  border-radius: 8px !important;
  border: 1px solid #000 !important;
  position: relative !important;
  background-color: #fff !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
}

.search-icon {
  color: #6c757d;
  font-size: 1.1rem;
  margin-right: 0.5rem;
}

.search-arrow-faded {
  color: #000 !important;
  font-size: 1.25rem !important;
}

.search-container button.search-clear-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  padding: 0 !important;
  border: none !important;
  background: #fff !important;
  background-color: #fff !important;
  color: #000 !important;
  cursor: pointer;
  border-radius: 50% !important;
  transition: background-color 0.2s;
  box-shadow: none !important;
  right: 36px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.search-container button.search-clear-btn:hover {
  background: #f2f2f2 !important;
  background-color: #f2f2f2 !important;
}

.search-container button.search-clear-btn i {
  color: #000 !important;
  font-size: 0.95rem !important;
  line-height: 1 !important;
}

.search-input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
  padding: 0 68px 0 0 !important; /* Space for X + arrow on the right to prevent text overlap */
  height: auto !important;
  flex: 1; /* Make input take remaining space so arrow is pushed to edge */
}

.clear-icon {
  color: #ccc;
  cursor: pointer;
  font-size: 1.1rem;
  margin-left: 0.5rem;
  transition: color 0.2s;
}

.clear-icon:hover {
  color: #888;
}

/* OVERRIDE GENERIC .desktop-filter-bar button rules */
.desktop-filter-bar button.btn-dark-action,
.filter-bar-mobile button.btn-dark-action {
  display: flex !important;
  height: 38px !important;
  padding: 10.183px 24px !important; /* Figma spec */
  justify-content: center !important;
  align-items: center !important;
  gap: 12.729px !important; /* Figma spec */
  border-radius: 8px !important;
  background-color: #000000 !important;
  color: #ffffff !important;
  border: none !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  transition: background-color 0.2s, transform 0.1s !important;
  white-space: nowrap !important;
  /* BUG FIX: Override the huge width: 100% rule applied to all buttons in this bar */
  width: auto !important;
  min-width: 0 !important;
  flex: 0 0 auto !important;
}

.desktop-filter-bar button.btn-favorites,
.filter-bar-mobile button.btn-favorites {
  padding: 0 !important;
  width: 44px !important;
  min-width: 44px !important;
  flex: 0 0 44px !important;
}

.btn-favorites .bi-heart-fill {
  color: #ffffff !important;
}

.btn-favorites .bi-heart-fill.active-heart {
  color: #FF9600 !important;
}

/* Dot de filtros activos: inline, dentro del flow del botón (Figma) */
.filters-active-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #FF9600;
  flex-shrink: 0;
}

.desktop-filter-bar button.btn-dark-action:hover,
.filter-bar-mobile button.btn-dark-action:hover {
  background-color: #333333 !important;
  background: #333333 !important;
  color: #ffffff !important;
}

.desktop-filter-bar button.btn-dark-action:active,
.filter-bar-mobile button.btn-dark-action:active {
  transform: scale(0.98) !important;
}

/* Restyled Reset Button to fit the new top bar (Spinning Icon) */
.desktop-filter-bar button.reset-icons-btn,
.filter-bar-mobile button.reset-icons-btn {
  display: flex !important;
  height: 38px !important;
  width: 38px !important;
  min-width: 38px !important; /* OVERRIDE FIX */
  flex: 0 0 38px !important; /* OVERRIDE FIX */
  padding: 0 !important;
  justify-content: center !important;
  align-items: center !important;
  border-radius: 8px !important;
  background-color: transparent !important;
  color: #000000 !important; /* Black edges and icon as requested */
  border: 1px solid #000000 !important; /* Black edges */
  margin-right: 8px !important; /* Más respiro hacia el botón de Filtros */
  transition: all 0.3s ease !important;
  cursor: pointer;
}

.desktop-filter-bar button.reset-icons-btn i,
.filter-bar-mobile button.reset-icons-btn i {
  font-size: 1.2rem;
  transition: transform 0.4s ease-in-out;
}

.desktop-filter-bar button.reset-icons-btn:hover,
.filter-bar-mobile button.reset-icons-btn:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.desktop-filter-bar button.reset-icons-btn:hover i,
.filter-bar-mobile button.reset-icons-btn:hover i {
  transform: rotate(-180deg);
}

/* Profile and Notifications adjust */
.profile-notifications-container {
  display: flex;
  justify-content: flex-end; /* Strictly right aligned */
  width: 100%;
  margin-bottom: 0.5rem; /* Small spacing before the bar below */
  gap: 12px;
  align-items: center;
  /* Removed artificial right padding to let it flow naturally to browser edge */
}

.profile-notifications-container ::ng-deep app-profile-icon .profile-icon-btn,
.profile-notifications-container ::ng-deep app-notification-bell .notification-bell {
  width: 40px !important;
  height: 40px !important;
  flex-shrink: 0 !important;
  min-width: 40px !important;
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Modal Overlay */
.filters-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  backdrop-filter: blur(4px);
}

.filters-modal-content {
  background: #fff;
  border-radius: 12.729px;
  width: 515px;
  max-width: 92%; /* Better fit on small screens */
  box-shadow: 0 31.823px 63.645px -15.275px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.3s ease forwards;
  padding: 32px 40px 40px 40px !important;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Date picker container */
.date-picker-container {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  background-color: #fff;
  gap: 2px !important; /* Menos espacio: calendario más cerca de "Desde" */
  border: 2px solid #cccccc; /* Cambiado a gris */
  border-radius: 8px;
  font-size: 0.9rem;
  height: 2.25rem;
  padding: 0 6px !important; /* Un poco menos padding para dar sitio a "Hasta" */
  width: 100% !important;
  box-sizing: border-box;
}

/* Que el mirror de Material que muestra "Desde" no se corte */
.date-picker-container ::ng-deep .mat-date-range-input-wrapper:first-of-type .mat-date-range-input-mirror {
  min-width: 5.5rem !important;
  max-width: none !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

.date-picker-container ::ng-deep .mat-date-range-input-wrapper:first-of-type {
  min-width: 5.5rem !important;
  overflow: visible !important;
}

/* Que "Hasta" se vea completo y más a la izquierda */
.date-picker-container ::ng-deep .mat-date-range-input-end-wrapper .mat-date-range-input-mirror {
  min-width: 5.5rem !important;
  max-width: none !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

.date-picker-container ::ng-deep .mat-date-range-input-end-wrapper {
  min-width: 5.5rem !important;
  overflow: visible !important;
}

.desktop-date-picker,
.date-picker {
  position: relative;
  padding: 0px;
}

.date-picker-toggle {
  color: gray;
  order: -1; /* Icono del calendario antes de "Desde" */
  margin-right: 0 !important; /* Desde más cerca del calendario */
}

.desktop-date-picker-input,
.date-picker {
  flex: 1;
}

.desktop-date-picker-input {
  border: none !important;
  background: transparent !important;
  padding: 0 4px !important;
  height: 90% !important;
  font-size: 0.9rem !important;
  width: 40% !important;
  min-width: 4rem !important; /* "Desde" se ve completo */
  color: #6c757d !important; /* Gris claro, igual que Buscar por nombre */
}

.desktop-date-picker-input::placeholder {
  color: #6c757d !important; /* Gris claro, igual que Buscar por nombre */
}

/* Cards container */
.cards-container {
  width: 100% !important;
  max-width: 100% !important;
  overflow-y: visible; /* El scroll está en app-content-container */
  box-sizing: border-box;
  margin: 0 !important;
  padding: 0 10px 40px 10px !important; /* Añadimos padding-bottom para que la última tarjeta pase de sobra el gap oscuro */
  position: relative;
  z-index: 2; /* Asegurar que el contenedor de cards esté por encima del fondo */
}

.cards-container .row {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
  display: flex !important;
  flex-wrap: wrap !important;
}

/* Card styling */
.cards-container .col-lg-4,
.cards-container .col-md-6,
.cards-container .col-12 {
  padding: 0.5rem !important;
  transition: transform 0.2s;
  flex: 0 0 auto !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* Estilos específicos para tarjetas */
app-card-real-estate {
  display: block;
  width: 100%;
  height: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  z-index: 2; /* Asegurar que las cards estén por encima del fondo */
}

/* Navegación y paginación */
.navigationCards {
  width: 100% !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 100px;
}

.navigationCards nav {
  margin-right: 5px;
}

.page-item a {
  color: #f09502 !important;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 1rem auto;
  padding: 0.5rem;
  width: 100%;
}

.pagination-controls .btn-prev,
.pagination-controls .btn-next {
  background-color: #ff8c00;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 8px;
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.pagination-controls .btn-prev:hover:not([disabled]),
.pagination-controls .btn-next:hover:not([disabled]) {
  background-color: #e57a00;
  transform: scale(1.05);
}

.pagination-controls .btn-prev[disabled],
.pagination-controls .btn-next[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-page {
  padding: 8px 14px;
  border: 1px solid #d48402;
  background-color: transparent;
  color: #d48402;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  font-size: 14px;
}

.btn-page.active {
  background-color: #d48402;
  color: #fff;
  font-weight: bold;
  border-color: #d48402;
}

.btn-page:hover:not(.active) {
  background-color: rgba(212, 132, 2, 0.2);
  color: #d48402;
}

.ellipsis {
  padding: 8px 12px;
  color: #999;
  cursor: default;
  font-size: 14px;
}

.btn-prev:hover,
.btn-next:hover {
  background-color: rgba(212, 132, 2, 0.2);
  color: #d48402;
}

.no-properties-message {
  text-align: center;
  color: #333;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 2rem auto;
  padding: 1.5rem;
  border-radius: 12px;
  border: 2px solid #f09502;
  background-color: rgba(240, 149, 2, 0.08);
}

/* Scrollbar removido - ahora está en app-content-container */

/* Angular Material overrides - el texto visible "Desde" lo pinta .mat-date-range-input-mirror */
::ng-deep .mat-date-range-input-container.mat-date-range-input-container {
  align-items: normal;
}

/* Primer wrapper (Desde): sin clase start-wrapper en el DOM, es el primero */
::ng-deep .mat-date-range-input-container .mat-date-range-input-wrapper:not(.mat-date-range-input-end-wrapper) {
  min-width: 5.5rem !important;
  overflow: visible !important;
}

::ng-deep .mat-date-range-input-container .mat-date-range-input-wrapper:not(.mat-date-range-input-end-wrapper) .mat-date-range-input-mirror {
  min-width: 5.5rem !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

::ng-deep .mat-date-range-input-start-wrapper {
  width: 50% !important;
  max-width: 50% !important;
  min-width: 5.5rem !important;
  overflow: visible !important;
}

::ng-deep .mat-date-range-input-start-wrapper input.mat-start-date,
::ng-deep .mat-date-range-input-start-wrapper .desktop-date-picker-input {
  min-width: 5.5ch !important;
  width: 100% !important;
  box-sizing: border-box;
  overflow: visible !important;
}

::ng-deep .mat-date-range-input-end-wrapper {
  width: 50% !important;
  max-width: 50% !important;
  min-width: 5.5rem !important; /* "Hasta" completo */
  overflow: visible !important;
}

::ng-deep .mat-date-range-input-container .mat-date-range-input-end-wrapper .mat-date-range-input-mirror {
  min-width: 5.5rem !important;
  max-width: none !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

::ng-deep .mat-date-range-input-separator {
  margin: 8px 2px !important; /* Menos margen: "Hasta" más a la izquierda */
  color: gray;
}

/* ======================================
   RESPONSIVE MEDIA QUERIES
   ====================================== */

/* Mobile (Small screens) */
@media (max-width: 576px) {
  .filter-bar-container-desktop {
    display: block !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .profile-notifications-container {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    padding-right: 0 !important;   /* sin espacio lateral derecho extra */
    margin-bottom: 0 !important;
  }

  .desktop-filter-bar {
    width: 100% !important;
    padding-bottom: 40px !important; /* 40 entre barra de búsqueda y las tarjetas */
    margin-top: 0 !important;
  }
  
  .desktop-filter-bar .d-flex.w-100 {
    gap: 26px !important;
    justify-content: flex-start !important;
  }
  
  /* Reducir padding lateral del contenedor de barra para que el buscador
     no se corte en móvil (el padding: 0 18px inline era demasiado). */
  .desktop-filter-bar {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .search-container {
    padding: 8px 10px !important;
    gap: 6px !important;
    flex: 1 1 0 !important;
    min-width: 0 !important;
    overflow: hidden;
  }

  /* Ocultar la flecha decorativa del buscador en móvil (consume espacio) */
  .search-arrow-faded {
    display: none !important;
  }

  /* El input no debe desbordarse */
  .search-input {
    padding: 0 !important;
    min-width: 0 !important;
  }

  .action-buttons-container {
    gap: 8px !important;
    flex-shrink: 0 !important;
  }

  /* Prevent overlap and fix margins */
  /* Eliminado ya que se aplica en las reglas de arriba */

  /* Mobile filter toggle behavior */
  .filter-bar-mobile {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }
  
  .filter-bar-mobile.show {
    display: block !important;
    width: 97vw !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* Single column layout for filters */
  .filter-bar-mobile.show .custom-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 0.75rem !important;
    width: 100% !important;
  }
  
  /* Single column cards - IMPORTANTE: Asegurar ancho completo */
  .cards-container {
    padding: 0 5px !important;
    height: auto !important; /* El scroll lo gestiona .content-container; alturas 100vh anidadas empujaban los iconos fuera del viewport en móvil */
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  .cards-container .row {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding: 0.375rem !important;
    margin: 0 !important;
  }
  
  /* Asegurar que la navbar-router-container no tenga padding extra */
  .navbar-router-container {
    padding: 0 !important;
    width: 100% !important;
  }
  
  /* Ocultar scrollbar en móvil */
  .scrollable-container::-webkit-scrollbar {
    display: none;
  }
  
  .scrollable-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  /* Pagination en móvil */
  .pagination-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 0.2rem;
    width: 100%;
    padding: 0.5rem 0;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  
  .pagination-controls::-webkit-scrollbar {
    display: none;
  }

  .btn-page {
    padding: 4px 9px;
    font-size: 12px;
    flex-shrink: 0;
  }

  .pagination-controls .btn-prev,
  .pagination-controls .btn-next {
    padding: 0.3rem 0.5rem !important;
    font-size: 0.85rem !important;
    flex-shrink: 0;
  }
}

/* Tablet (Small to medium screens) */
@media (min-width: 577px) and (max-width: 767px) {
  .filter-bar-container-desktop {
    display: block !important;
  }
  
  .desktop-filter-bar .d-flex.w-100 {
    gap: 26px !important;
    justify-content: space-between !important;
  }
  
  .search-container {
    padding: 8px 12px !important;
    gap: 8px !important;
    flex: 1 1 auto !important;
    min-width: 0 !important;
  }
  
  .action-buttons-container {
    gap: 16px !important;
    flex-shrink: 0 !important;
  }
  
  /* Prevent overlap with top navbar by giving top padding to the notifications container */
  .profile-notifications-container {
    padding-top: 65px !important;
  }
  
  /* Mobile filter toggle behavior */
  .filter-bar-mobile {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }
  
  .filter-bar-mobile.show {
    display: block !important;
    width: 94vw !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* Two column layout for filters */
  .filter-bar-mobile.show .custom-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.5rem !important;
    width: 100% !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-last-child(2),
  .filter-bar-mobile.show .custom-grid > div:last-child {
    grid-column: span 2 !important;
  }
  
  /* Two column cards - IMPORTANTE: Asegurar ancho completo */
  .cards-container {
    padding: 0 5px !important;
    height: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  .cards-container .row {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.5rem !important;
    width: 100% !important;
    padding: 0.25rem !important;
    margin: 0 !important;
  }
  
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0.25rem !important;
    margin: 0 !important;
  }
  
  /* Asegurar que la navbar-router-container no tenga padding extra */
  .navbar-router-container {
    padding: 0 !important;
    width: 100% !important;
  }
  
  .custom-grid .custom-col.first-row {
    flex: 1 1 50%;
    max-width: 50%;
  }
  
  .custom-grid .custom-col.second-row {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* iPad and larger tablets (768px - 1024px) */
/* Corrección para iPad y tablets (768px - 1366px) */
/* Mejorar layout del grid de filtros para iPad y tablets */
@media (min-width: 768px) and (max-width: 1366px) {

  /* De 768px en adelante el menú lateral (negro) está visible y NO hay
     hamburguesa ni navbar superior en Oportunidades, así que el padding-top
     de compensación (65px) sobraba y dejaba un hueco grande encima de los
     iconos. Lo igualamos al desktop normal (sin padding extra). */
  .profile-notifications-container {
    padding-top: 0 !important;
  }

  /* Estilos generales para el contenedor mobile y sus elementos */
  .filter-bar-container-mobile {
    display: block !important;
    position: relative !important;
    z-index: 100 !important;
    width: 100% !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
  
  /* Ocultar barra de filtros desktop */
  .filter-bar-container-desktop {
    display: none !important;
  }
  
  /* Botón toggle centrado y con buen tamaño */
  .toggle-filter-btn {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    margin: 0 0 15px 0 !important;
    padding: 10px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    border-radius: 8px !important;
    border: none !important;
    font-size: 16px !important;
    cursor: pointer !important;
  }
  
  /* Estilos para la barra de filtros cuando está oculta */
  .filter-bar-mobile {
    display: none !important;
  }
  
  /* Estilos para la barra de filtros cuando está visible */
  .filter-bar-mobile.show {
    display: block !important;
    width: 100% !important;
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 15px !important;
    margin-bottom: 20px !important;
    box-sizing: border-box !important;
  }
  
  /* Estructura de grid mejorada con más espacio entre elementos */
  .filter-bar-mobile.show .custom-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
    width: 100% !important;
  }

  /* Dar suficiente altura a cada elemento del grid */
  .filter-bar-mobile.show .custom-grid > div {
    min-height: 45px !important;
  }
  
  /* Estilos para los inputs, selects y date pickers */
  .filter-bar-mobile.show input,
  .filter-bar-mobile.show select {
    width: 100% !important;
    height: 45px !important;
    padding: 8px 12px !important;
    border: 2px solid #F09502 !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    background-color: white !important;
    box-sizing: border-box !important;
  }
  
  /* Mejorar el contenedor del date picker */
  .filter-bar-mobile.show .date-picker-container {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    height: 45px !important;
    padding: 0 12px !important;
    border: 2px solid #F09502 !important;
    border-radius: 8px !important;
    background-color: white !important;
    box-sizing: border-box !important;
  }
  
  /* Mejorar la visibilidad de las fechas */
  .filter-bar-mobile.show .desktop-date-picker-input {
    width: 40% !important;
    height: 35px !important;
    border: none !important;
    background: transparent !important;
    font-size: 14px !important;
    text-align: center !important;
    box-sizing: border-box !important;
  }
  
  /* Estilos para el botón de resetear filtros */
  .filter-bar-mobile.show .filter-buttons {
    grid-column: span 2 !important;
    width: 100% !important;
  }
  
  .filter-bar-mobile.show .filter-btn {
    width: 100% !important;
    height: 45px !important;
    padding: 8px 12px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    border: none !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que los elementos ocupen todo el espacio */
  .filter-bar-mobile.show .col-lg,
  .filter-bar-mobile.show .col-lg-4,
  .filter-bar-mobile.show .col-md-6,
  .filter-bar-mobile.show .col-sm-6,
  .filter-bar-mobile.show .col-sx-12 {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  /* Posicionamiento de elementos en grid para mayor claridad */
  .filter-bar-mobile.show .custom-grid > div:nth-child(1) {
    grid-column: 1 / 2 !important;
    grid-row: 1 / 2 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(2) {
    grid-column: 2 / 3 !important;
    grid-row: 1 / 2 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(3) {
    grid-column: 1 / 2 !important;
    grid-row: 2 / 3 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(4) {
    grid-column: 2 / 3 !important;
    grid-row: 2 / 3 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(5) {
    grid-column: 1 / 3 !important;
    grid-row: 3 / 4 !important;
  }
}

/* Ajustes para el contenedor de tarjetas */
/* Corrección específica para el grid de filtros manteniendo el ancho de las cards */
@media (min-width: 768px) and (max-width: 1366px) {
  /* Estilos generales para el contenedor mobile y sus elementos */
  .filter-bar-container-mobile {
    display: block !important;
    position: relative !important;
    z-index: 100 !important;
    width: 100vw !important; /* Usar viewport width */
    max-width: 100vw !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
  
  /* Ocultar barra de filtros desktop */
  .filter-bar-container-desktop {
    display: none !important;
  }
  
  /* Botón toggle */
  .toggle-filter-btn {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: calc(100% - 20px) !important;
    margin: 0 10px 15px 10px !important;
  }
  
  /* Estilos para la barra de filtros cuando está visible */
  .filter-bar-mobile.show {
    display: block !important;
    width: calc(100% - 20px) !important; /* Ancho completo con margen lateral */
    margin: 0 10px !important;
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 15px !important;
    box-sizing: border-box !important;
  }
  
  /* Estructura de grid simplificada: 2 columnas, y el botón abajo ocupando todo el ancho */
  .filter-bar-mobile.show .custom-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
    width: 100% !important;
  }
  
  /* El botón de resetear filtros ocupa todo el ancho */
  .filter-bar-mobile.show .custom-grid > div:last-child {
    grid-column: 1 / 3 !important; /* Span 2 columnas */
  }
  
  /* Centrar el texto del botón */
  .filter-bar-mobile.show .filter-btn {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    height: 45px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    font-size: 16px !important;
    border: none !important;
    border-radius: 8px !important;
  }
  
  /* Mejorar inputs y selects */
  .filter-bar-mobile.show input,
  .filter-bar-mobile.show select,
  .filter-bar-mobile.show .date-picker-container {
    width: 100% !important;
    height: 45px !important;
    padding: 8px 12px !important;
    border: 2px solid #F09502 !important;
    border-radius: 8px !important;
    box-sizing: border-box !important;
  }
}

/* MANTENER LOS ESTILOS DE LAS CARDS QUE YA FUNCIONAN CORRECTAMENTE */
@media (min-width: 768px) and (max-width: 1366px) {
  /* No tocar el estilo de las cards */
  .cards-container {
    padding: 0 10px !important;
    width: 100% !important; /* Usar ancho del contenedor padre */
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  /* Configuración de grid de 2 columnas ocupando todo el ancho */
  .cards-container .row {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 1rem !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que cada celda del grid ocupe su espacio */
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0 !important;
    margin-bottom: 0.25rem !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que la tarjeta ocupe todo el ancho de su contenedor */
  app-card-real-estate {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }

  .toggle-filter-btn {
    width: 200px !important; /* Ancho fijo reducido */
    margin: 0 0 15px 10px !important; /* Alineado a la izquierda con margen izquierdo */
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 45px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    border: none !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    box-sizing: border-box !important;
  }
}





/* Large tablets and small desktops (1025px - 1366px) */
@media (min-width: 1024px) and (max-width: 1366px) {
  /* Hide mobile filters, show desktop */
  .filter-bar-container-mobile {
    display: none !important;
  }
  
  .filter-bar-container-desktop {
    display: block !important;
  }
  
  /* Horizontal flex layout for desktop filters */
  .desktop-filter-bar .custom-grid {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 10px !important;
    width: 100% !important;
    align-items: center !important;
  }
  
  /* Equal width columns */
  .desktop-filter-bar .custom-col {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    max-width: none !important;
  }
  
  /* Three column cards for large tablets/small desktops */
  .cards-container {
    height: auto !important;
    padding: 0 10px !important;
    width: 100% !important;
    max-width: 100% !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  .cards-container .row {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 1rem !important;
    width: 100% !important;
    padding: 0.5rem !important;
  }
  
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0 !important;
    margin-bottom: 0.5rem !important;
  }
  
  .custom-grid .custom-col.first-row {
    flex: 1 1 33.33%;
    max-width: 33.33%;
  }
  
  .custom-grid .custom-col.second-row {
    flex: 1 1 50%;
    max-width: 50%;
  }
  
  /* Date picker container en desktop */
  .desktop-filter-bar .date-picker-container {
    flex: 1 1 auto;
    min-width: 180px;
    max-width: 200px;
    padding: 0.5rem;
  }
  
  .desktop-filter-bar .date-picker-container input {
    font-size: 0.9rem;
  }
  
  /* Resetear la estructura del grid para una fila única */
  .desktop-filter-bar .row.w-100.g-2.custom-grid {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: 100% !important;
    gap: 10px;
    margin: 0 !important;
  }
  
  /* Dimensiones uniformes para todas las columnas */
  .desktop-filter-bar .custom-col,
  .desktop-filter-bar .custom-col.first-row,
  .desktop-filter-bar .custom-col.second-row,
  .desktop-filter-bar .custom-col.col-reset {
    flex: 1 !important;
    width: auto !important;
    max-width: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  /* Uniformidad en inputs, selects y date picker */
  .desktop-filter-bar input[type="text"],
  .desktop-filter-bar select,
  .desktop-filter-bar .date-picker-container {
    width: 100% !important;
    height: 2.25rem !important;
    padding: 0 8px !important;
    min-width: unset !important;
    max-width: unset !important;
  }

  /* Botón Resetear filtros más pequeño + gradiente (desktop 1024-1366) */
  .desktop-filter-bar .filter-buttons .reset-button {
    width: auto !important;
    min-width: 120px !important;
    max-width: 180px !important;
    height: 2.25rem !important;
    padding: 0.35rem 0.75rem !important;
    font-size: 0.85rem !important;
    background: #FFC15B !important;
    color: #ffffff !important;
    border: 1px solid rgba(255, 193, 91, 0.8) !important;
  }
}

/* Larger desktops (1367px+) */
@media (min-width: 1367px) {
  /* Hide mobile filters, show desktop */
  .filter-bar-container-mobile {
    display: none !important;
  }
  
  .filter-bar-container-desktop {
    display: block !important;
  }
  
  /* Desktop filter layout */
  .desktop-filter-bar {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
  }
  
  .desktop-filter-bar .row.w-100.g-2.custom-grid {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: 100% !important;
    gap: 10px;
    margin: 0 !important;
  }
  
  .desktop-filter-bar .custom-col {
    flex: 1 !important;
    width: auto !important;
    max-width: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .desktop-filter-bar input[type="text"],
  .desktop-filter-bar select,
  .desktop-filter-bar .date-picker-container {
    width: 100% !important;
    height: 2.25rem !important;
    min-width: unset !important;
    max-width: unset !important;
  }
  
  /* Standard card grid */
  .cards-container {
    height: auto;
    padding: 0 10px;
    width: 100% !important;
    max-width: 100% !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  /* Ajustar el botón de resetear filtros */
  .desktop-filter-bar .filter-buttons {
    width: 100% !important;
    display: flex;
    height: 2.25rem !important;
    flex: 1 !important;
  }
  
  .desktop-filter-bar .filter-buttons .reset-button {
    width: auto !important;
    min-width: 120px !important;
    max-width: 180px !important;
    height: 2.25rem !important;
    padding: 0.35rem 0.75rem !important;
    font-size: 0.85rem !important;
    white-space: nowrap;
    background: #FFC15B !important;
    color: #ffffff !important;
    border: 1px solid rgba(255, 193, 91, 0.8) !important;
  }

  .desktop-filter-bar .filter-buttons .reset-button:hover {
    background: #FFC15B !important;
    filter: brightness(1.05);
    color: #ffffff !important;
  }

  /* Campana e icono perfil alineados en desktop */
  .desktop-filter-bar .filter-actions-row .reset-button {
    flex: 0 0 auto;
  }

  /* Date picker en desktop grande */
  .date-picker-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  
  .date-picker-container input.desktop-date-picker-input {
    font-size: 0.92rem;
    text-align: center;
    padding: 0 4px;
    height: 35px;
    line-height: 1.2;
    box-sizing: border-box;
  }
  
  .date-picker-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
  }
}

/* Ajustes específicos para diferentes rangos de pantalla */
@media (max-width: 1440px) and (min-width: 1325px) {
  .cards-container {
    height: auto;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
}

@media (max-width: 1325px) {
  .cards-container {
    height: auto;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
}

@media (min-width: 992px) {
  .filter-bar-mobile button,
  .desktop-filter-bar button {
    min-width: 80px;
    width: auto;
    flex: 0 0 auto;
  }
}

/* Solución final para grid desktop - 3 columnas */

/* Solución final para grid desktop - 3 columnas con scrollbar visible */

/* Larger desktops (1367px+) */
@media (min-width: 1367px) {
  /* Asegurar que tenemos 3 columnas */
  .cards-container {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 10px !important;
    overflow-y: visible !important; /* El scroll está en app-content-container */
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  /* Ajustar el contenedor de las tarjetas */
  .cards-container.row {
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
  }

  /* Cada columna ocupa exactamente 1/3 del espacio */
  .cards-container .col-lg-4 {
    flex: 0 0 33.333333% !important;
    max-width: 33.333333% !important;
    padding: 0.5rem !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */
  app-card-real-estate {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  /* Scrollbar removido - ahora está en app-content-container */
}

/* Large tablets and small desktops (1025px - 1366px) */
@media (min-width: 1025px) and (max-width: 1366px) {
  /* Asegurar que tenemos 3 columnas también aquí */
  .cards-container {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 10px !important;
    overflow-y: visible !important; /* El scroll está en app-content-container */
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  /* Ajustar el contenedor de las tarjetas */
  .cards-container.row {
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
  }

  /* Cada columna ocupa exactamente 1/3 del espacio */
  .cards-container .col-lg-4 {
    flex: 0 0 33.333333% !important;
    max-width: 33.333333% !important;
    padding: 0.5rem !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */
  app-card-real-estate {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  /* Scrollbar removido - ahora está en app-content-container */
}

/* Corregir alineación del contenedor de paginación */
.pagination-controls {
  flex: 0 0 100% !important;
  width: 100% !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  padding: 0.5rem !important;
  padding-bottom: 2.5rem !important;
}

/* Corregir problemas con el ng-container */
.cards-container > ng-container {
  display: contents !important;
}

/* ======================================
   SPINNER STYLES
   ====================================== */
.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #181b25;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.spinner-container mat-spinner {
  width: 80px !important;
  height: 80px !important;
  margin-bottom: 30px;
}

.spinner-container .loading-text {
  color: white;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
  font-family: "Montserrat", sans-serif;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Asegurar que el spinner tenga el color correcto */
.spinner-container .frontProgress {
  color: #f09502 !important;
}


/* ======================================
   NEW UI MODAL STYLES (FILTERS)
   ====================================== */
label.modal-label {
    color: #000 !important;
    font-family: 'Montserrat', sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: normal !important;
    margin-bottom: 0.5rem !important;
    white-space: nowrap !important;
}

.modal-input-grey {
    background-color: #F6F6F6 !important;
    border: none !important;
    border-radius: 10px !important;
    padding: 0.75rem 1rem !important;
    color: #333 !important;
    font-size: 1rem !important;
    box-shadow: none !important;
    min-height: 2.75rem !important;
    display: flex;
    align-items: center;
}

.modal-input-grey:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255,140,0,0.2) !important;
}

.modal-date-container {
    background-color: transparent !important;
    border: none !important;
    padding: 0 !important;
}

.modal-date-container .mat-date-range {
    display: flex;
    justify-content: space-between;
    background-image: none !important;
    padding: 0 !important;
    border-radius: 0 !important;
    gap: 12px;
    width: 100%;
}

::ng-deep .modal-date-container .mat-date-range-input-inner {
    border-radius: 10px;
    background-color: #F6F6F6;
    padding: 0.75rem 1rem;
    border: none;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
}

.modal-date-input {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    width: 100%;
    color: #333;
    outline: none;
    text-align: center;
}

::ng-deep .modal-date-container .mat-date-range-input-container {
    display: flex !important;
    gap: 12px !important;
    width: 100% !important;
}

::ng-deep .modal-date-container .mat-date-range-input-separator {
    display: none !important; /* Escondemos el guion entre las fechas */
}

::ng-deep .modal-date-container .mat-date-range-input-wrapper {
    background-color: #F6F6F6 !important;
    border-radius: 10px !important;
    padding: 0.75rem 1rem !important;
    flex: 1 1 50% !important;
    width: 50% !important;
    max-width: 50% !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

::ng-deep .modal-date-container .mat-date-range-input-mirror,
::ng-deep .modal-date-container input.mat-start-date,
::ng-deep .modal-date-container input.mat-end-date {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    text-align: center;
    color: #333;
}

.btn-modal-outline {
    background-color: #fff !important;
    color: #000 !important;
    border: 1px solid #000 !important;
    border-radius: 12px;
    font-family: 'Montserrat', sans-serif !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    line-height: normal !important;
    transition: all 0.2s;
}

.btn-modal-outline:hover {
    background-color: #f8f9fa !important;
}

.btn-modal-solid {
    background-color: #000 !important;
    color: #fff !important;
    border: 1px solid #000 !important;
    border-radius: 12px;
    font-family: 'Montserrat', sans-serif !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    line-height: normal !important;
    transition: all 0.2s;
}

.btn-modal-solid:hover {
    background-color: #212529 !important;
}

/* ======================================
   RESPONSIVE WILDCARD (SEARCH & FILTERS)
   ====================================== */

.filter-bar-container-desktop {
  display: block !important;
}

.search-filter-inner-flex {
  gap: 70px;
}

@media (max-width: 991px) {
  /* Tablet / iPad Portrait */
  .search-filter-inner-flex {
    flex-wrap: nowrap !important;
    gap: 10px !important;
  }
  .search-container {
    flex: 1 1 auto !important;
    width: auto !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .action-buttons-container {
    flex: 0 0 auto !important;
    justify-content: flex-end !important;
  }
}

@media (max-width: 575px) {
  /* Mobile Phones */
  .search-filter-inner-flex {
    flex-wrap: nowrap !important;
    gap: 26px !important;
  }
  .search-container {
    flex: 1 1 auto !important;
    width: auto !important;
    padding: 10px 16px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .action-buttons-container {
    flex: 0 0 auto !important;
    justify-content: flex-end !important;
    width: auto !important;
    gap: 16px !important;
  }
  
  /* Make the filter button square */
  .action-buttons-container button.filters-btn-responsive {
    flex: 0 0 44px !important;
    width: 44px !important;
    min-width: 44px !important;
    padding: 0 !important;
  }
  
  /* Mantain sizes of reset icons and favorites */
  .action-buttons-container button.reset-icons-btn,
  .action-buttons-container button.btn-favorites {
    flex: 0 0 44px !important;
    width: 44px !important;
    min-width: 44px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/cards-real-estate/cards-real-estate.component.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;;;;EAIE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC,EAAE,YAAY;EAC9C,mCAAmC,EAAE,gBAAgB;AACvD;;AAEA,iEAAiE;AACjE;EACE;;;yEAGuE;EACvE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA,gFAAgF;AAChF;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;;;;;;;;;EASE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,0EAA0E;AAC1E;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,gFAAgF;AAChF;;;EAGE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;;EAEE,WAAW;EACX,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;2CAE2C;;AAE3C,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B,EAAE,kCAAkC;AACpE;;AAEA;EACE,WAAW;EACX,8BAA8B,EAAE,kCAAkC;AACpE;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gEAAgE;EAChE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wBAAwB,EAAE,uCAAuC;EACjE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,qDAAqD;EAChF,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;;EAEE,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;;;;;;;;EAQE,cAAc,QAAQ,6CAA6C;EACnE,gBAAgB,OAAO,6DAA6D;EACpF,eAAe,QAAQ,uCAAuC;EAC9D,yBAAyB,EAAE,oBAAoB;EAC/C,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;AACV;;AAEA;;;;;;EAME,OAAO;EACP,eAAe;EACf,yBAAyB,EAAE,oBAAoB;EAC/C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,wFAAwF;AACxF;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,mDAAmD,EAAE,2CAA2C;EAChG,yBAAyB,EAAE,kBAAkB;EAC7C,mDAAmD,EAAE,+BAA+B;EACpF,eAAe;EACf,8FAA8F;EAC9F,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAE,uBAAuB;AACvC;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;2CAE2C;;AAE3C;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC,EAAE,4CAA4C;EACpF,oBAAoB,EAAE,yCAAyC;EAC/D,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB,EAAE,yDAAyD;EACpF,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B,EAAE,6DAA6D;EAC7F,uBAAuB;EACvB,OAAO,EAAE,+DAA+D;AAC1E;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,sDAAsD;AACtD;;EAEE,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC,EAAE,eAAe;EAClD,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB,EAAE,eAAe;EACzC,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,4DAA4D;EAC5D,8BAA8B;EAC9B,mFAAmF;EACnF,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,iEAAiE;AACjE;;EAEE,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B,EAAE,iBAAiB;EAC7C,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;EACrB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB,EAAE,sCAAsC;EACjE,oCAAoC,EAAE,gBAAgB;EACtD,4BAA4B,EAAE,0CAA0C;EACxE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,yBAAyB,EAAE,2BAA2B;EACtD,WAAW;EACX,qBAAqB,EAAE,uCAAuC;EAC9D,SAAS;EACT,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,cAAc,EAAE,gCAAgC;EAChD,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,mBAAmB,EAAE,mDAAmD;EACxE,yBAAyB,EAAE,oBAAoB;EAC/C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB,EAAE,mDAAmD;EAC9E,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,qDAAqD;AACrD;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS,EAAE,0CAA0C;EACrD,0BAA0B,EAAE,mCAAmC;AACjE;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B,EAAE,2BAA2B;EACvD,yBAAyB,EAAE,4CAA4C;AACzE;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;AACzE;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB,EAAE,4CAA4C;EACjE,sBAAsB;EACtB,oBAAoB;EACpB,oCAAoC,EAAE,mFAAmF;EACzH,kBAAkB;EAClB,UAAU,EAAE,kEAAkE;AAChF;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;;;EAGE,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU,EAAE,sDAAsD;AACpE;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iDAAiD;AACnD;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,6DAA6D;;AAE7D,gGAAgG;AAChG;EACE,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B,EAAE,qBAAqB;EACnD,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B,EAAE,6CAA6C;EACzE,WAAW;AACb;;AAEA;;2CAE2C;;AAE3C,2BAA2B;AAC3B;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B,IAAI,sCAAsC;IACrE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,+BAA+B,EAAE,8CAA8C;IAC/E,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,sCAAsC;EACxC;;EAEA;sEACoE;EACpE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,yEAAyE;EACzE;IACE,wBAAwB;EAC1B;;EAEA,iCAAiC;EACjC;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA,oCAAoC;EACpC,uDAAuD;;EAEvD,kCAAkC;EAClC;IACE,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA,8DAA8D;EAC9D;IACE,yBAAyB;IACzB,uBAAuB,EAAE,sHAAsH;IAC/I,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA,mEAAmE;EACnE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,iCAAiC;IACjC,6BAA6B;IAC7B,cAAc;EAChB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,yCAAyC;EAC3C;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA,yFAAyF;EACzF;IACE,4BAA4B;EAC9B;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;IACxB,gDAAgD;IAChD,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA,2DAA2D;EAC3D;IACE,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA,mEAAmE;EACnE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C,oDAAoD;AACpD,2DAA2D;AAC3D;;EAEE;;;kEAGgE;EAChE;IACE,yBAAyB;EAC3B;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;EAC1B;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;IACxB,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA,wDAAwD;EACxD;IACE,wBAAwB;EAC1B;;EAEA,yDAAyD;EACzD;IACE,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA,gEAAgE;EAChE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,2BAA2B;EAC7B;;EAEA,oDAAoD;EACpD;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA,0CAA0C;EAC1C;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,oCAAoC;IACpC,6BAA6B;IAC7B,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA,yCAAyC;EACzC;IACE,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;IAClC,0BAA0B;IAC1B,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA,8CAA8C;EAC9C;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,sDAAsD;EACtD;;;;;IAKE,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,6DAA6D;EAC7D;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA,2CAA2C;AAC3C,oFAAoF;AACpF;EACE,gEAAgE;EAChE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB,EAAE,wBAAwB;IACjD,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;EAC1B;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;EACrC;;EAEA,yDAAyD;EACzD;IACE,yBAAyB;IACzB,mCAAmC,EAAE,sCAAsC;IAC3E,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA,yFAAyF;EACzF;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,qDAAqD;EACrD;IACE,6BAA6B,EAAE,oBAAoB;EACrD;;EAEA,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;IACpC,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA,6BAA6B;EAC7B;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,iCAAiC;EACnC;AACF;;AAEA,qEAAqE;AACrE;EACE,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,sBAAsB,EAAE,oCAAoC;IAC5D,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,iCAAiC;IACjC,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,+DAA+D;EAC/D;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA,sDAAsD;EACtD;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,iCAAiC;IACjC,iCAAiC;EACnC;;EAEA,iEAAiE;EACjE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB,EAAE,wBAAwB;IACjD,gCAAgC,EAAE,iDAAiD;IACnF,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,uBAAuB;IACvB,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;;;;;AAMA,uDAAuD;AACvD;EACE,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,+CAA+C;EAC/C;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,wBAAwB;EACxB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA,wDAAwD;EACxD;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,wDAAwD;EACxD;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA,kDAAkD;EAClD;;;;IAIE,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,iDAAiD;EACjD;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,uEAAuE;EACvE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,mCAAmC;IACnC,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,oDAAoD;EACtD;AACF;;AAEA,8BAA8B;AAC9B;EACE,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,0BAA0B;EAC1B;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,uBAAuB;EACvB;IACE,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,yCAAyC;EACzC;IACE,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,mCAAmC;IACnC,6BAA6B;IAC7B,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,oDAAoD;EACtD;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA,gDAAgD;EAChD;IACE,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;AACF;;AAEA,kDAAkD;;AAElD,wEAAwE;;AAExE,8BAA8B;AAC9B;EACE,oCAAoC;EACpC;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B,EAAE,4CAA4C;IAC5E,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,0CAA0C;EAC1C;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,6DAA6D;AAC/D;;AAEA,uDAAuD;AACvD;EACE,iDAAiD;EACjD;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B,EAAE,4CAA4C;IAC5E,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,0CAA0C;EAC1C;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,6DAA6D;AAC/D;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA;;2CAE2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;AAC3B;;;AAGA;;2CAE2C;AAC3C;IACI,sBAAsB;IACtB,gDAAgD;IAChD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,gCAAgC;IAChC,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iCAAiC;IACjC,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB,EAAE,yCAAyC;AACvE;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;IAGI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,gDAAgD;IAChD,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,gDAAgD;IAChD,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;2CAE2C;;AAE3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;EAClB;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,oCAAoC;IACpC,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA,kCAAkC;EAClC;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA,+CAA+C;EAC/C;;IAEE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;EAC5B;AACF","sourcesContent":["/* Ocultar scrollbars duplicados - el scroll está en app-content-container */\n.cards-container::-webkit-scrollbar,\n.filter-bar-container-mobile::-webkit-scrollbar,\n.filter-bar-container-desktop::-webkit-scrollbar,\n.scrollable-container::-webkit-scrollbar {\n  display: none !important;\n  width: 0 !important;\n}\n\n.cards-container,\n.filter-bar-container-mobile,\n.filter-bar-container-desktop {\n  scrollbar-width: none !important; /* Firefox */\n  -ms-overflow-style: none !important; /* IE and Edge */\n}\n\n/* Estilos específicos para el componente app-cards-real-estate */\n:host {\n  /* Oportunidades es el único hijo del navbar-router-container (no tiene\n     app-navbar-user). Debe ocupar TODO su alto (calc(100vh-30px)); si el\n     content-container se quedara en calc(100vh-60px), faltarían 30px abajo\n     y el fondo del navbar-router-container asomaría (franja inferior). */\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  overflow-x: hidden !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* El content-container llena el alto disponible y conserva su scroll interno. */\n:host ::ng-deep app-content-container {\n  flex: 1 1 0 !important;\n  min-height: 0 !important;\n}\n\n:host ::ng-deep app-content-container > .content-container {\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: 100% !important;\n}\n\n/* Romper min-width:auto en TODA la cadena interna */\n.cards-container,\n.cards-container .row,\n.cards-container .col-lg-4,\n.cards-container .col-md-6,\n.cards-container .col-12,\n.filter-bar-container-desktop,\n.filter-bar-container-mobile,\n.desktop-filter-bar,\n.desktop-filter-bar .d-flex.w-100 {\n  min-width: 0 !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Asegurar que todos los contenedores del componente usen todo el ancho */\n:host > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Remove the grey shadowing (separation) between header and content container */\n:host ::ng-deep .content-container,\n:host ::ng-deep .content-container.variant-white,\n:host ::ng-deep app-content-container .content-container {\n  box-shadow: none !important;\n  border-top: none !important;\n}\n\n/* Contenedor de filtros debe usar el ancho disponible sin romper padding */\n.filter-bar-container-mobile,\n.filter-bar-container-desktop {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* ======================================\n   FILTER BAR AND CARD CONTAINER FIXES\n   ====================================== */\n\n/* Base filter container styles */\n.filter-bar-container-mobile {\n  width: 100%;\n  position: relative;\n  margin-bottom: 2rem !important; /* Espacio entre filtros y cards */\n}\n\n.filter-bar-container-desktop {\n  width: 100%;\n  margin-bottom: 2rem !important; /* Espacio entre filtros y cards */\n}\n\n/* Improved filter bar mobile */\n.filter-bar-mobile {\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 0.75rem;\n  z-index: 10;\n  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  display: none !important; /* Forzar que esté oculto por defecto */\n  opacity: 0;\n  visibility: hidden;\n}\n\n.filter-bar-mobile.show {\n  display: block !important; /* Forzar que se muestre cuando tenga la clase show */\n  opacity: 1 !important;\n  visibility: visible !important;\n  z-index: 10;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.filter-bar-mobile.hide {\n  transform: translateY(-10%);\n  opacity: 0;\n  visibility: hidden;\n}\n\n/* Filter toggle button */\n.toggle-filter-btn {\n  margin: 0px 10px;\n  background-color: #ff8c00;\n  color: #ffffff;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n  width: auto;\n  display: flex;\n  align-items: center;\n}\n\n.toggle-filter-btn:hover {\n  background-color: #e57a00;\n  transform: scale(1.02);\n}\n\n/* Barra de filtros */\n.filter-bar-mobile,\n.desktop-filter-bar {\n  margin-bottom: 0.25rem !important;\n}\n\n/* Filter inputs and controls */\n.filter-bar-mobile input,\n.desktop-filter-bar input,\n.filter-bar-mobile select,\n.desktop-filter-bar select,\n.filter-bar-mobile button,\n.desktop-filter-bar button,\n.filter-bar-mobile .date-picker,\n.desktop-filter-bar .desktop-date-picker {\n  flex: 1 1 auto;       /* Todos ocupan el mismo espacio disponible */\n  min-width: 110px;      /* Puedes ajustar este valor según el espacio que dispongas */\n  padding: 0.5rem;       /* Asegura consistencia en el padding */\n  border: 2px solid #cccccc; /* Cambiado a gris */\n  border-radius: 8px;\n  font-size: 0.9rem;\n  width: 100% !important;\n  height: 2.25rem !important;\n  box-sizing: border-box;\n}\n\n.filter-bar-mobile .filter-btn {\n  flex: 1 1 calc(50% - 10px);\n  text-align: center;\n}\n\n.filter-buttons {\n  display: flex;\n  width: 100%;\n  gap: 6px;\n}\n\n.filter-bar-mobile input[type=\"text\"],\n.desktop-filter-bar input[type=\"text\"],\n.filter-bar-mobile select,\n.desktop-filter-bar select,\n.filter-bar-mobile button,\n.desktop-filter-bar button {\n  flex: 1;\n  padding: 0.5rem;\n  border: 2px solid #cccccc; /* Cambiado a gris */\n  border-radius: 8px;\n  font-size: 0.9rem;\n  height: 2.25rem; \n  padding: 0.25rem 0.5rem;\n}\n\n.filter-bar-mobile select.order-by-dropdown,\n.desktop-filter-bar select.order-by-dropdown {\n  margin-right: 10px;\n}\n\n/* Estado del proyecto y Orden Rentabilidad en gris claro, igual que Buscar por nombre */\n.desktop-filter-bar select.status-dropdown,\n.desktop-filter-bar select.price-dropdown,\n.filter-bar-mobile select.status-dropdown,\n.filter-bar-mobile select.price-dropdown {\n  color: #6c757d !important;\n}\n\n.desktop-filter-bar select.status-dropdown option,\n.desktop-filter-bar select.price-dropdown option,\n.filter-bar-mobile select.status-dropdown option,\n.filter-bar-mobile select.price-dropdown option {\n  color: #212529;\n}\n\n.filter-bar-mobile button,\n.desktop-filter-bar button {\n  background-color: #FF8C00;\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.filter-bar-mobile button:hover,\n.desktop-filter-bar button:hover {\n  background-color: #E57A00;\n  transform: scale(1.01);\n}\n\n.filter-btn,\n.reset-button {\n  background-color: rgba(255, 140, 0, 0.3) !important; /* Naranja transparente light por defecto */\n  color: #ff8c00 !important; /* Texto naranja */\n  border: 2px solid rgba(255, 140, 0, 0.5) !important; /* Borde naranja transparente */\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s, color 0.3s, border-color 0.3s, opacity 0.3s;\n  width: 100% !important;\n  height: 100% !important;\n  opacity: 0.7; /* Visible pero light */\n}\n\n/* Fila con Resetear filtros + campana + icono perfil (desktop) */\n.filter-actions-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n/* ======================================\n   NEW UI TOP BAR STYLES (SEARCH & BUTTONS)\n   ====================================== */\n\n.desktop-filter-bar .d-flex.w-100 {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-start !important; /* Allow items to naturally pack from left */\n  gap: 71px !important; /* Strict 71px gap requested from Figma */\n  align-self: stretch !important;\n}\n\n.search-container {\n  display: flex !important;\n  width: auto !important;\n  height: 38px !important;\n  padding: 10px 16px !important;\n  align-items: center !important;\n  gap: 18px !important;\n  flex: 1 1 auto !important; /* Allow search bar to stretch and fill remaining space */\n  border-radius: 8px !important;\n  border: 1px solid #000 !important;\n  position: relative !important;\n  background-color: #fff !important;\n  box-shadow: none !important;\n  box-sizing: border-box !important;\n}\n\n.search-icon {\n  color: #6c757d;\n  font-size: 1.1rem;\n  margin-right: 0.5rem;\n}\n\n.search-arrow-faded {\n  color: #000 !important;\n  font-size: 1.25rem !important;\n}\n\n.search-container button.search-clear-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 24px !important;\n  height: 24px !important;\n  min-width: 24px !important;\n  padding: 0 !important;\n  border: none !important;\n  background: #fff !important;\n  background-color: #fff !important;\n  color: #000 !important;\n  cursor: pointer;\n  border-radius: 50% !important;\n  transition: background-color 0.2s;\n  box-shadow: none !important;\n  right: 36px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n}\n\n.search-container button.search-clear-btn:hover {\n  background: #f2f2f2 !important;\n  background-color: #f2f2f2 !important;\n}\n\n.search-container button.search-clear-btn i {\n  color: #000 !important;\n  font-size: 0.95rem !important;\n  line-height: 1 !important;\n}\n\n.search-input {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n  padding: 0 68px 0 0 !important; /* Space for X + arrow on the right to prevent text overlap */\n  height: auto !important;\n  flex: 1; /* Make input take remaining space so arrow is pushed to edge */\n}\n\n.clear-icon {\n  color: #ccc;\n  cursor: pointer;\n  font-size: 1.1rem;\n  margin-left: 0.5rem;\n  transition: color 0.2s;\n}\n\n.clear-icon:hover {\n  color: #888;\n}\n\n/* OVERRIDE GENERIC .desktop-filter-bar button rules */\n.desktop-filter-bar button.btn-dark-action,\n.filter-bar-mobile button.btn-dark-action {\n  display: flex !important;\n  height: 38px !important;\n  padding: 10.183px 24px !important; /* Figma spec */\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 12.729px !important; /* Figma spec */\n  border-radius: 8px !important;\n  background-color: #000000 !important;\n  color: #ffffff !important;\n  border: none !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  transition: background-color 0.2s, transform 0.1s !important;\n  white-space: nowrap !important;\n  /* BUG FIX: Override the huge width: 100% rule applied to all buttons in this bar */\n  width: auto !important;\n  min-width: 0 !important;\n  flex: 0 0 auto !important;\n}\n\n.desktop-filter-bar button.btn-favorites,\n.filter-bar-mobile button.btn-favorites {\n  padding: 0 !important;\n  width: 44px !important;\n  min-width: 44px !important;\n  flex: 0 0 44px !important;\n}\n\n.btn-favorites .bi-heart-fill {\n  color: #ffffff !important;\n}\n\n.btn-favorites .bi-heart-fill.active-heart {\n  color: #FF9600 !important;\n}\n\n/* Dot de filtros activos: inline, dentro del flow del botón (Figma) */\n.filters-active-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #FF9600;\n  flex-shrink: 0;\n}\n\n.desktop-filter-bar button.btn-dark-action:hover,\n.filter-bar-mobile button.btn-dark-action:hover {\n  background-color: #333333 !important;\n  background: #333333 !important;\n  color: #ffffff !important;\n}\n\n.desktop-filter-bar button.btn-dark-action:active,\n.filter-bar-mobile button.btn-dark-action:active {\n  transform: scale(0.98) !important;\n}\n\n/* Restyled Reset Button to fit the new top bar (Spinning Icon) */\n.desktop-filter-bar button.reset-icons-btn,\n.filter-bar-mobile button.reset-icons-btn {\n  display: flex !important;\n  height: 38px !important;\n  width: 38px !important;\n  min-width: 38px !important; /* OVERRIDE FIX */\n  flex: 0 0 38px !important; /* OVERRIDE FIX */\n  padding: 0 !important;\n  justify-content: center !important;\n  align-items: center !important;\n  border-radius: 8px !important;\n  background-color: transparent !important;\n  color: #000000 !important; /* Black edges and icon as requested */\n  border: 1px solid #000000 !important; /* Black edges */\n  margin-right: 8px !important; /* Más respiro hacia el botón de Filtros */\n  transition: all 0.3s ease !important;\n  cursor: pointer;\n}\n\n.desktop-filter-bar button.reset-icons-btn i,\n.filter-bar-mobile button.reset-icons-btn i {\n  font-size: 1.2rem;\n  transition: transform 0.4s ease-in-out;\n}\n\n.desktop-filter-bar button.reset-icons-btn:hover,\n.filter-bar-mobile button.reset-icons-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n.desktop-filter-bar button.reset-icons-btn:hover i,\n.filter-bar-mobile button.reset-icons-btn:hover i {\n  transform: rotate(-180deg);\n}\n\n/* Profile and Notifications adjust */\n.profile-notifications-container {\n  display: flex;\n  justify-content: flex-end; /* Strictly right aligned */\n  width: 100%;\n  margin-bottom: 0.5rem; /* Small spacing before the bar below */\n  gap: 12px;\n  align-items: center;\n  /* Removed artificial right padding to let it flow naturally to browser edge */\n}\n\n.profile-notifications-container ::ng-deep app-profile-icon .profile-icon-btn,\n.profile-notifications-container ::ng-deep app-notification-bell .notification-bell {\n  width: 40px !important;\n  height: 40px !important;\n  flex-shrink: 0 !important;\n  min-width: 40px !important;\n  min-height: 40px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* Modal Overlay */\n.filters-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n  backdrop-filter: blur(4px);\n}\n\n.filters-modal-content {\n  background: #fff;\n  border-radius: 12.729px;\n  width: 515px;\n  max-width: 92%; /* Better fit on small screens */\n  box-shadow: 0 31.823px 63.645px -15.275px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  animation: modalFadeIn 0.3s ease forwards;\n  padding: 32px 40px 40px 40px !important;\n}\n\n@keyframes modalFadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Date picker container */\n.date-picker-container {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  background-color: #fff;\n  gap: 2px !important; /* Menos espacio: calendario más cerca de \"Desde\" */\n  border: 2px solid #cccccc; /* Cambiado a gris */\n  border-radius: 8px;\n  font-size: 0.9rem;\n  height: 2.25rem;\n  padding: 0 6px !important; /* Un poco menos padding para dar sitio a \"Hasta\" */\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n/* Que el mirror de Material que muestra \"Desde\" no se corte */\n.date-picker-container ::ng-deep .mat-date-range-input-wrapper:first-of-type .mat-date-range-input-mirror {\n  min-width: 5.5rem !important;\n  max-width: none !important;\n  overflow: visible !important;\n  white-space: nowrap !important;\n}\n\n.date-picker-container ::ng-deep .mat-date-range-input-wrapper:first-of-type {\n  min-width: 5.5rem !important;\n  overflow: visible !important;\n}\n\n/* Que \"Hasta\" se vea completo y más a la izquierda */\n.date-picker-container ::ng-deep .mat-date-range-input-end-wrapper .mat-date-range-input-mirror {\n  min-width: 5.5rem !important;\n  max-width: none !important;\n  overflow: visible !important;\n  white-space: nowrap !important;\n}\n\n.date-picker-container ::ng-deep .mat-date-range-input-end-wrapper {\n  min-width: 5.5rem !important;\n  overflow: visible !important;\n}\n\n.desktop-date-picker,\n.date-picker {\n  position: relative;\n  padding: 0px;\n}\n\n.date-picker-toggle {\n  color: gray;\n  order: -1; /* Icono del calendario antes de \"Desde\" */\n  margin-right: 0 !important; /* Desde más cerca del calendario */\n}\n\n.desktop-date-picker-input,\n.date-picker {\n  flex: 1;\n}\n\n.desktop-date-picker-input {\n  border: none !important;\n  background: transparent !important;\n  padding: 0 4px !important;\n  height: 90% !important;\n  font-size: 0.9rem !important;\n  width: 40% !important;\n  min-width: 4rem !important; /* \"Desde\" se ve completo */\n  color: #6c757d !important; /* Gris claro, igual que Buscar por nombre */\n}\n\n.desktop-date-picker-input::placeholder {\n  color: #6c757d !important; /* Gris claro, igual que Buscar por nombre */\n}\n\n/* Cards container */\n.cards-container {\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow-y: visible; /* El scroll está en app-content-container */\n  box-sizing: border-box;\n  margin: 0 !important;\n  padding: 0 10px 40px 10px !important; /* Añadimos padding-bottom para que la última tarjeta pase de sobra el gap oscuro */\n  position: relative;\n  z-index: 2; /* Asegurar que el contenedor de cards esté por encima del fondo */\n}\n\n.cards-container .row {\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box;\n  display: flex !important;\n  flex-wrap: wrap !important;\n}\n\n/* Card styling */\n.cards-container .col-lg-4,\n.cards-container .col-md-6,\n.cards-container .col-12 {\n  padding: 0.5rem !important;\n  transition: transform 0.2s;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Estilos específicos para tarjetas */\napp-card-real-estate {\n  display: block;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  z-index: 2; /* Asegurar que las cards estén por encima del fondo */\n}\n\n/* Navegación y paginación */\n.navigationCards {\n  width: 100% !important;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 100px;\n}\n\n.navigationCards nav {\n  margin-right: 5px;\n}\n\n.page-item a {\n  color: #f09502 !important;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 1rem auto;\n  padding: 0.5rem;\n  width: 100%;\n}\n\n.pagination-controls .btn-prev,\n.pagination-controls .btn-next {\n  background-color: #ff8c00;\n  color: #ffffff;\n  border: 2px solid #ffffff;\n  border-radius: 8px;\n  padding: 0.5rem;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.pagination-controls .btn-prev:hover:not([disabled]),\n.pagination-controls .btn-next:hover:not([disabled]) {\n  background-color: #e57a00;\n  transform: scale(1.05);\n}\n\n.pagination-controls .btn-prev[disabled],\n.pagination-controls .btn-next[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-page {\n  padding: 8px 14px;\n  border: 1px solid #d48402;\n  background-color: transparent;\n  color: #d48402;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  font-size: 14px;\n}\n\n.btn-page.active {\n  background-color: #d48402;\n  color: #fff;\n  font-weight: bold;\n  border-color: #d48402;\n}\n\n.btn-page:hover:not(.active) {\n  background-color: rgba(212, 132, 2, 0.2);\n  color: #d48402;\n}\n\n.ellipsis {\n  padding: 8px 12px;\n  color: #999;\n  cursor: default;\n  font-size: 14px;\n}\n\n.btn-prev:hover,\n.btn-next:hover {\n  background-color: rgba(212, 132, 2, 0.2);\n  color: #d48402;\n}\n\n.no-properties-message {\n  text-align: center;\n  color: #333;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 2rem auto;\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 2px solid #f09502;\n  background-color: rgba(240, 149, 2, 0.08);\n}\n\n/* Scrollbar removido - ahora está en app-content-container */\n\n/* Angular Material overrides - el texto visible \"Desde\" lo pinta .mat-date-range-input-mirror */\n::ng-deep .mat-date-range-input-container.mat-date-range-input-container {\n  align-items: normal;\n}\n\n/* Primer wrapper (Desde): sin clase start-wrapper en el DOM, es el primero */\n::ng-deep .mat-date-range-input-container .mat-date-range-input-wrapper:not(.mat-date-range-input-end-wrapper) {\n  min-width: 5.5rem !important;\n  overflow: visible !important;\n}\n\n::ng-deep .mat-date-range-input-container .mat-date-range-input-wrapper:not(.mat-date-range-input-end-wrapper) .mat-date-range-input-mirror {\n  min-width: 5.5rem !important;\n  overflow: visible !important;\n  white-space: nowrap !important;\n}\n\n::ng-deep .mat-date-range-input-start-wrapper {\n  width: 50% !important;\n  max-width: 50% !important;\n  min-width: 5.5rem !important;\n  overflow: visible !important;\n}\n\n::ng-deep .mat-date-range-input-start-wrapper input.mat-start-date,\n::ng-deep .mat-date-range-input-start-wrapper .desktop-date-picker-input {\n  min-width: 5.5ch !important;\n  width: 100% !important;\n  box-sizing: border-box;\n  overflow: visible !important;\n}\n\n::ng-deep .mat-date-range-input-end-wrapper {\n  width: 50% !important;\n  max-width: 50% !important;\n  min-width: 5.5rem !important; /* \"Hasta\" completo */\n  overflow: visible !important;\n}\n\n::ng-deep .mat-date-range-input-container .mat-date-range-input-end-wrapper .mat-date-range-input-mirror {\n  min-width: 5.5rem !important;\n  max-width: none !important;\n  overflow: visible !important;\n  white-space: nowrap !important;\n}\n\n::ng-deep .mat-date-range-input-separator {\n  margin: 8px 2px !important; /* Menos margen: \"Hasta\" más a la izquierda */\n  color: gray;\n}\n\n/* ======================================\n   RESPONSIVE MEDIA QUERIES\n   ====================================== */\n\n/* Mobile (Small screens) */\n@media (max-width: 576px) {\n  .filter-bar-container-desktop {\n    display: block !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .profile-notifications-container {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n    padding-right: 0 !important;   /* sin espacio lateral derecho extra */\n    margin-bottom: 0 !important;\n  }\n\n  .desktop-filter-bar {\n    width: 100% !important;\n    padding-bottom: 40px !important; /* 40 entre barra de búsqueda y las tarjetas */\n    margin-top: 0 !important;\n  }\n  \n  .desktop-filter-bar .d-flex.w-100 {\n    gap: 26px !important;\n    justify-content: flex-start !important;\n  }\n  \n  /* Reducir padding lateral del contenedor de barra para que el buscador\n     no se corte en móvil (el padding: 0 18px inline era demasiado). */\n  .desktop-filter-bar {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n\n  .search-container {\n    padding: 8px 10px !important;\n    gap: 6px !important;\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n    overflow: hidden;\n  }\n\n  /* Ocultar la flecha decorativa del buscador en móvil (consume espacio) */\n  .search-arrow-faded {\n    display: none !important;\n  }\n\n  /* El input no debe desbordarse */\n  .search-input {\n    padding: 0 !important;\n    min-width: 0 !important;\n  }\n\n  .action-buttons-container {\n    gap: 8px !important;\n    flex-shrink: 0 !important;\n  }\n\n  /* Prevent overlap and fix margins */\n  /* Eliminado ya que se aplica en las reglas de arriba */\n\n  /* Mobile filter toggle behavior */\n  .filter-bar-mobile {\n    display: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n  }\n  \n  .filter-bar-mobile.show {\n    display: block !important;\n    width: 97vw !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n  }\n  \n  /* Single column layout for filters */\n  .filter-bar-mobile.show .custom-grid {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 0.75rem !important;\n    width: 100% !important;\n  }\n  \n  /* Single column cards - IMPORTANTE: Asegurar ancho completo */\n  .cards-container {\n    padding: 0 5px !important;\n    height: auto !important; /* El scroll lo gestiona .content-container; alturas 100vh anidadas empujaban los iconos fuera del viewport en móvil */\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  .cards-container .row {\n    display: flex !important;\n    flex-direction: column !important;\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: 0 0 100% !important;\n    padding: 0.375rem !important;\n    margin: 0 !important;\n  }\n  \n  /* Asegurar que la navbar-router-container no tenga padding extra */\n  .navbar-router-container {\n    padding: 0 !important;\n    width: 100% !important;\n  }\n  \n  /* Ocultar scrollbar en móvil */\n  .scrollable-container::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .scrollable-container {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  \n  /* Pagination en móvil */\n  .pagination-controls {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    gap: 0.2rem;\n    width: 100%;\n    padding: 0.5rem 0;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  \n  .pagination-controls::-webkit-scrollbar {\n    display: none;\n  }\n\n  .btn-page {\n    padding: 4px 9px;\n    font-size: 12px;\n    flex-shrink: 0;\n  }\n\n  .pagination-controls .btn-prev,\n  .pagination-controls .btn-next {\n    padding: 0.3rem 0.5rem !important;\n    font-size: 0.85rem !important;\n    flex-shrink: 0;\n  }\n}\n\n/* Tablet (Small to medium screens) */\n@media (min-width: 577px) and (max-width: 767px) {\n  .filter-bar-container-desktop {\n    display: block !important;\n  }\n  \n  .desktop-filter-bar .d-flex.w-100 {\n    gap: 26px !important;\n    justify-content: space-between !important;\n  }\n  \n  .search-container {\n    padding: 8px 12px !important;\n    gap: 8px !important;\n    flex: 1 1 auto !important;\n    min-width: 0 !important;\n  }\n  \n  .action-buttons-container {\n    gap: 16px !important;\n    flex-shrink: 0 !important;\n  }\n  \n  /* Prevent overlap with top navbar by giving top padding to the notifications container */\n  .profile-notifications-container {\n    padding-top: 65px !important;\n  }\n  \n  /* Mobile filter toggle behavior */\n  .filter-bar-mobile {\n    display: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n  }\n  \n  .filter-bar-mobile.show {\n    display: block !important;\n    width: 94vw !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n  }\n  \n  /* Two column layout for filters */\n  .filter-bar-mobile.show .custom-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 0.5rem !important;\n    width: 100% !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-last-child(2),\n  .filter-bar-mobile.show .custom-grid > div:last-child {\n    grid-column: span 2 !important;\n  }\n  \n  /* Two column cards - IMPORTANTE: Asegurar ancho completo */\n  .cards-container {\n    padding: 0 5px !important;\n    height: auto !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  .cards-container .row {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 0.5rem !important;\n    width: 100% !important;\n    padding: 0.25rem !important;\n    margin: 0 !important;\n  }\n  \n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: none !important;\n    padding: 0.25rem !important;\n    margin: 0 !important;\n  }\n  \n  /* Asegurar que la navbar-router-container no tenga padding extra */\n  .navbar-router-container {\n    padding: 0 !important;\n    width: 100% !important;\n  }\n  \n  .custom-grid .custom-col.first-row {\n    flex: 1 1 50%;\n    max-width: 50%;\n  }\n  \n  .custom-grid .custom-col.second-row {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n}\n\n/* iPad and larger tablets (768px - 1024px) */\n/* Corrección para iPad y tablets (768px - 1366px) */\n/* Mejorar layout del grid de filtros para iPad y tablets */\n@media (min-width: 768px) and (max-width: 1366px) {\n\n  /* De 768px en adelante el menú lateral (negro) está visible y NO hay\n     hamburguesa ni navbar superior en Oportunidades, así que el padding-top\n     de compensación (65px) sobraba y dejaba un hueco grande encima de los\n     iconos. Lo igualamos al desktop normal (sin padding extra). */\n  .profile-notifications-container {\n    padding-top: 0 !important;\n  }\n\n  /* Estilos generales para el contenedor mobile y sus elementos */\n  .filter-bar-container-mobile {\n    display: block !important;\n    position: relative !important;\n    z-index: 100 !important;\n    width: 100% !important;\n    padding: 0 10px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Ocultar barra de filtros desktop */\n  .filter-bar-container-desktop {\n    display: none !important;\n  }\n  \n  /* Botón toggle centrado y con buen tamaño */\n  .toggle-filter-btn {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: 100% !important;\n    margin: 0 0 15px 0 !important;\n    padding: 10px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    border-radius: 8px !important;\n    border: none !important;\n    font-size: 16px !important;\n    cursor: pointer !important;\n  }\n  \n  /* Estilos para la barra de filtros cuando está oculta */\n  .filter-bar-mobile {\n    display: none !important;\n  }\n  \n  /* Estilos para la barra de filtros cuando está visible */\n  .filter-bar-mobile.show {\n    display: block !important;\n    width: 100% !important;\n    background: white !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;\n    padding: 15px !important;\n    margin-bottom: 20px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Estructura de grid mejorada con más espacio entre elementos */\n  .filter-bar-mobile.show .custom-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 15px !important;\n    width: 100% !important;\n  }\n\n  /* Dar suficiente altura a cada elemento del grid */\n  .filter-bar-mobile.show .custom-grid > div {\n    min-height: 45px !important;\n  }\n  \n  /* Estilos para los inputs, selects y date pickers */\n  .filter-bar-mobile.show input,\n  .filter-bar-mobile.show select {\n    width: 100% !important;\n    height: 45px !important;\n    padding: 8px 12px !important;\n    border: 2px solid #F09502 !important;\n    border-radius: 8px !important;\n    font-size: 14px !important;\n    background-color: white !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Mejorar el contenedor del date picker */\n  .filter-bar-mobile.show .date-picker-container {\n    display: flex !important;\n    align-items: center !important;\n    width: 100% !important;\n    height: 45px !important;\n    padding: 0 12px !important;\n    border: 2px solid #F09502 !important;\n    border-radius: 8px !important;\n    background-color: white !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Mejorar la visibilidad de las fechas */\n  .filter-bar-mobile.show .desktop-date-picker-input {\n    width: 40% !important;\n    height: 35px !important;\n    border: none !important;\n    background: transparent !important;\n    font-size: 14px !important;\n    text-align: center !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Estilos para el botón de resetear filtros */\n  .filter-bar-mobile.show .filter-buttons {\n    grid-column: span 2 !important;\n    width: 100% !important;\n  }\n  \n  .filter-bar-mobile.show .filter-btn {\n    width: 100% !important;\n    height: 45px !important;\n    padding: 8px 12px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 8px !important;\n    font-size: 16px !important;\n    cursor: pointer !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que los elementos ocupen todo el espacio */\n  .filter-bar-mobile.show .col-lg,\n  .filter-bar-mobile.show .col-lg-4,\n  .filter-bar-mobile.show .col-md-6,\n  .filter-bar-mobile.show .col-sm-6,\n  .filter-bar-mobile.show .col-sx-12 {\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  /* Posicionamiento de elementos en grid para mayor claridad */\n  .filter-bar-mobile.show .custom-grid > div:nth-child(1) {\n    grid-column: 1 / 2 !important;\n    grid-row: 1 / 2 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(2) {\n    grid-column: 2 / 3 !important;\n    grid-row: 1 / 2 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(3) {\n    grid-column: 1 / 2 !important;\n    grid-row: 2 / 3 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(4) {\n    grid-column: 2 / 3 !important;\n    grid-row: 2 / 3 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(5) {\n    grid-column: 1 / 3 !important;\n    grid-row: 3 / 4 !important;\n  }\n}\n\n/* Ajustes para el contenedor de tarjetas */\n/* Corrección específica para el grid de filtros manteniendo el ancho de las cards */\n@media (min-width: 768px) and (max-width: 1366px) {\n  /* Estilos generales para el contenedor mobile y sus elementos */\n  .filter-bar-container-mobile {\n    display: block !important;\n    position: relative !important;\n    z-index: 100 !important;\n    width: 100vw !important; /* Usar viewport width */\n    max-width: 100vw !important;\n    padding: 0 10px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Ocultar barra de filtros desktop */\n  .filter-bar-container-desktop {\n    display: none !important;\n  }\n  \n  /* Botón toggle */\n  .toggle-filter-btn {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: calc(100% - 20px) !important;\n    margin: 0 10px 15px 10px !important;\n  }\n  \n  /* Estilos para la barra de filtros cuando está visible */\n  .filter-bar-mobile.show {\n    display: block !important;\n    width: calc(100% - 20px) !important; /* Ancho completo con margen lateral */\n    margin: 0 10px !important;\n    background: white !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;\n    padding: 15px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Estructura de grid simplificada: 2 columnas, y el botón abajo ocupando todo el ancho */\n  .filter-bar-mobile.show .custom-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 15px !important;\n    width: 100% !important;\n  }\n  \n  /* El botón de resetear filtros ocupa todo el ancho */\n  .filter-bar-mobile.show .custom-grid > div:last-child {\n    grid-column: 1 / 3 !important; /* Span 2 columnas */\n  }\n  \n  /* Centrar el texto del botón */\n  .filter-bar-mobile.show .filter-btn {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    width: 100% !important;\n    height: 45px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    font-size: 16px !important;\n    border: none !important;\n    border-radius: 8px !important;\n  }\n  \n  /* Mejorar inputs y selects */\n  .filter-bar-mobile.show input,\n  .filter-bar-mobile.show select,\n  .filter-bar-mobile.show .date-picker-container {\n    width: 100% !important;\n    height: 45px !important;\n    padding: 8px 12px !important;\n    border: 2px solid #F09502 !important;\n    border-radius: 8px !important;\n    box-sizing: border-box !important;\n  }\n}\n\n/* MANTENER LOS ESTILOS DE LAS CARDS QUE YA FUNCIONAN CORRECTAMENTE */\n@media (min-width: 768px) and (max-width: 1366px) {\n  /* No tocar el estilo de las cards */\n  .cards-container {\n    padding: 0 10px !important;\n    width: 100% !important; /* Usar ancho del contenedor padre */\n    max-width: 100% !important;\n    height: auto !important;\n    margin: 0 !important;\n    box-sizing: border-box !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  /* Configuración de grid de 2 columnas ocupando todo el ancho */\n  .cards-container .row {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 1rem !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que cada celda del grid ocupe su espacio */\n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: none !important;\n    padding: 0 !important;\n    margin-bottom: 0.25rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que la tarjeta ocupe todo el ancho de su contenedor */\n  app-card-real-estate {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .toggle-filter-btn {\n    width: 200px !important; /* Ancho fijo reducido */\n    margin: 0 0 15px 10px !important; /* Alineado a la izquierda con margen izquierdo */\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    height: 45px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 8px !important;\n    font-size: 16px !important;\n    box-sizing: border-box !important;\n  }\n}\n\n\n\n\n\n/* Large tablets and small desktops (1025px - 1366px) */\n@media (min-width: 1024px) and (max-width: 1366px) {\n  /* Hide mobile filters, show desktop */\n  .filter-bar-container-mobile {\n    display: none !important;\n  }\n  \n  .filter-bar-container-desktop {\n    display: block !important;\n  }\n  \n  /* Horizontal flex layout for desktop filters */\n  .desktop-filter-bar .custom-grid {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    gap: 10px !important;\n    width: 100% !important;\n    align-items: center !important;\n  }\n  \n  /* Equal width columns */\n  .desktop-filter-bar .custom-col {\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n    max-width: none !important;\n  }\n  \n  /* Three column cards for large tablets/small desktops */\n  .cards-container {\n    height: auto !important;\n    padding: 0 10px !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  .cards-container .row {\n    display: grid !important;\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 1rem !important;\n    width: 100% !important;\n    padding: 0.5rem !important;\n  }\n  \n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: none !important;\n    padding: 0 !important;\n    margin-bottom: 0.5rem !important;\n  }\n  \n  .custom-grid .custom-col.first-row {\n    flex: 1 1 33.33%;\n    max-width: 33.33%;\n  }\n  \n  .custom-grid .custom-col.second-row {\n    flex: 1 1 50%;\n    max-width: 50%;\n  }\n  \n  /* Date picker container en desktop */\n  .desktop-filter-bar .date-picker-container {\n    flex: 1 1 auto;\n    min-width: 180px;\n    max-width: 200px;\n    padding: 0.5rem;\n  }\n  \n  .desktop-filter-bar .date-picker-container input {\n    font-size: 0.9rem;\n  }\n  \n  /* Resetear la estructura del grid para una fila única */\n  .desktop-filter-bar .row.w-100.g-2.custom-grid {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n    width: 100% !important;\n    gap: 10px;\n    margin: 0 !important;\n  }\n  \n  /* Dimensiones uniformes para todas las columnas */\n  .desktop-filter-bar .custom-col,\n  .desktop-filter-bar .custom-col.first-row,\n  .desktop-filter-bar .custom-col.second-row,\n  .desktop-filter-bar .custom-col.col-reset {\n    flex: 1 !important;\n    width: auto !important;\n    max-width: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  /* Uniformidad en inputs, selects y date picker */\n  .desktop-filter-bar input[type=\"text\"],\n  .desktop-filter-bar select,\n  .desktop-filter-bar .date-picker-container {\n    width: 100% !important;\n    height: 2.25rem !important;\n    padding: 0 8px !important;\n    min-width: unset !important;\n    max-width: unset !important;\n  }\n\n  /* Botón Resetear filtros más pequeño + gradiente (desktop 1024-1366) */\n  .desktop-filter-bar .filter-buttons .reset-button {\n    width: auto !important;\n    min-width: 120px !important;\n    max-width: 180px !important;\n    height: 2.25rem !important;\n    padding: 0.35rem 0.75rem !important;\n    font-size: 0.85rem !important;\n    background: #FFC15B !important;\n    color: #ffffff !important;\n    border: 1px solid rgba(255, 193, 91, 0.8) !important;\n  }\n}\n\n/* Larger desktops (1367px+) */\n@media (min-width: 1367px) {\n  /* Hide mobile filters, show desktop */\n  .filter-bar-container-mobile {\n    display: none !important;\n  }\n  \n  .filter-bar-container-desktop {\n    display: block !important;\n  }\n  \n  /* Desktop filter layout */\n  .desktop-filter-bar {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n    justify-content: space-between;\n  }\n  \n  .desktop-filter-bar .row.w-100.g-2.custom-grid {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n    width: 100% !important;\n    gap: 10px;\n    margin: 0 !important;\n  }\n  \n  .desktop-filter-bar .custom-col {\n    flex: 1 !important;\n    width: auto !important;\n    max-width: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .desktop-filter-bar input[type=\"text\"],\n  .desktop-filter-bar select,\n  .desktop-filter-bar .date-picker-container {\n    width: 100% !important;\n    height: 2.25rem !important;\n    min-width: unset !important;\n    max-width: unset !important;\n  }\n  \n  /* Standard card grid */\n  .cards-container {\n    height: auto;\n    padding: 0 10px;\n    width: 100% !important;\n    max-width: 100% !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  /* Ajustar el botón de resetear filtros */\n  .desktop-filter-bar .filter-buttons {\n    width: 100% !important;\n    display: flex;\n    height: 2.25rem !important;\n    flex: 1 !important;\n  }\n  \n  .desktop-filter-bar .filter-buttons .reset-button {\n    width: auto !important;\n    min-width: 120px !important;\n    max-width: 180px !important;\n    height: 2.25rem !important;\n    padding: 0.35rem 0.75rem !important;\n    font-size: 0.85rem !important;\n    white-space: nowrap;\n    background: #FFC15B !important;\n    color: #ffffff !important;\n    border: 1px solid rgba(255, 193, 91, 0.8) !important;\n  }\n\n  .desktop-filter-bar .filter-buttons .reset-button:hover {\n    background: #FFC15B !important;\n    filter: brightness(1.05);\n    color: #ffffff !important;\n  }\n\n  /* Campana e icono perfil alineados en desktop */\n  .desktop-filter-bar .filter-actions-row .reset-button {\n    flex: 0 0 auto;\n  }\n\n  /* Date picker en desktop grande */\n  .date-picker-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n  }\n  \n  .date-picker-container input.desktop-date-picker-input {\n    font-size: 0.92rem;\n    text-align: center;\n    padding: 0 4px;\n    height: 35px;\n    line-height: 1.2;\n    box-sizing: border-box;\n  }\n  \n  .date-picker-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 35px;\n  }\n}\n\n/* Ajustes específicos para diferentes rangos de pantalla */\n@media (max-width: 1440px) and (min-width: 1325px) {\n  .cards-container {\n    height: auto;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n}\n\n@media (max-width: 1325px) {\n  .cards-container {\n    height: auto;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n}\n\n@media (min-width: 992px) {\n  .filter-bar-mobile button,\n  .desktop-filter-bar button {\n    min-width: 80px;\n    width: auto;\n    flex: 0 0 auto;\n  }\n}\n\n/* Solución final para grid desktop - 3 columnas */\n\n/* Solución final para grid desktop - 3 columnas con scrollbar visible */\n\n/* Larger desktops (1367px+) */\n@media (min-width: 1367px) {\n  /* Asegurar que tenemos 3 columnas */\n  .cards-container {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 10px !important;\n    overflow-y: visible !important; /* El scroll está en app-content-container */\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  /* Ajustar el contenedor de las tarjetas */\n  .cards-container.row {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n\n  /* Cada columna ocupa exactamente 1/3 del espacio */\n  .cards-container .col-lg-4 {\n    flex: 0 0 33.333333% !important;\n    max-width: 33.333333% !important;\n    padding: 0.5rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */\n  app-card-real-estate {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  /* Scrollbar removido - ahora está en app-content-container */\n}\n\n/* Large tablets and small desktops (1025px - 1366px) */\n@media (min-width: 1025px) and (max-width: 1366px) {\n  /* Asegurar que tenemos 3 columnas también aquí */\n  .cards-container {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 10px !important;\n    overflow-y: visible !important; /* El scroll está en app-content-container */\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  /* Ajustar el contenedor de las tarjetas */\n  .cards-container.row {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n\n  /* Cada columna ocupa exactamente 1/3 del espacio */\n  .cards-container .col-lg-4 {\n    flex: 0 0 33.333333% !important;\n    max-width: 33.333333% !important;\n    padding: 0.5rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */\n  app-card-real-estate {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  /* Scrollbar removido - ahora está en app-content-container */\n}\n\n/* Corregir alineación del contenedor de paginación */\n.pagination-controls {\n  flex: 0 0 100% !important;\n  width: 100% !important;\n  justify-content: center !important;\n  margin-top: 1rem !important;\n  padding: 0.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n/* Corregir problemas con el ng-container */\n.cards-container > ng-container {\n  display: contents !important;\n}\n\n/* ======================================\n   SPINNER STYLES\n   ====================================== */\n.spinner-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #181b25;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  backdrop-filter: blur(2px);\n}\n\n.spinner-container mat-spinner {\n  width: 80px !important;\n  height: 80px !important;\n  margin-bottom: 30px;\n}\n\n.spinner-container .loading-text {\n  color: white;\n  font-size: 20px;\n  font-weight: 500;\n  text-align: center;\n  margin-top: 20px;\n  font-family: \"Montserrat\", sans-serif;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* Asegurar que el spinner tenga el color correcto */\n.spinner-container .frontProgress {\n  color: #f09502 !important;\n}\n\n\n/* ======================================\n   NEW UI MODAL STYLES (FILTERS)\n   ====================================== */\nlabel.modal-label {\n    color: #000 !important;\n    font-family: 'Montserrat', sans-serif !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    line-height: normal !important;\n    margin-bottom: 0.5rem !important;\n    white-space: nowrap !important;\n}\n\n.modal-input-grey {\n    background-color: #F6F6F6 !important;\n    border: none !important;\n    border-radius: 10px !important;\n    padding: 0.75rem 1rem !important;\n    color: #333 !important;\n    font-size: 1rem !important;\n    box-shadow: none !important;\n    min-height: 2.75rem !important;\n    display: flex;\n    align-items: center;\n}\n\n.modal-input-grey:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(255,140,0,0.2) !important;\n}\n\n.modal-date-container {\n    background-color: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n}\n\n.modal-date-container .mat-date-range {\n    display: flex;\n    justify-content: space-between;\n    background-image: none !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n    gap: 12px;\n    width: 100%;\n}\n\n::ng-deep .modal-date-container .mat-date-range-input-inner {\n    border-radius: 10px;\n    background-color: #F6F6F6;\n    padding: 0.75rem 1rem;\n    border: none;\n    flex: 1;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.modal-date-input {\n    border: none !important;\n    background: transparent !important;\n    padding: 0 !important;\n    width: 100%;\n    color: #333;\n    outline: none;\n    text-align: center;\n}\n\n::ng-deep .modal-date-container .mat-date-range-input-container {\n    display: flex !important;\n    gap: 12px !important;\n    width: 100% !important;\n}\n\n::ng-deep .modal-date-container .mat-date-range-input-separator {\n    display: none !important; /* Escondemos el guion entre las fechas */\n}\n\n::ng-deep .modal-date-container .mat-date-range-input-wrapper {\n    background-color: #F6F6F6 !important;\n    border-radius: 10px !important;\n    padding: 0.75rem 1rem !important;\n    flex: 1 1 50% !important;\n    width: 50% !important;\n    max-width: 50% !important;\n    min-width: 0 !important;\n    box-sizing: border-box !important;\n    cursor: pointer !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n::ng-deep .modal-date-container .mat-date-range-input-mirror,\n::ng-deep .modal-date-container input.mat-start-date,\n::ng-deep .modal-date-container input.mat-end-date {\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    text-align: center;\n    color: #333;\n}\n\n.btn-modal-outline {\n    background-color: #fff !important;\n    color: #000 !important;\n    border: 1px solid #000 !important;\n    border-radius: 12px;\n    font-family: 'Montserrat', sans-serif !important;\n    font-size: 15px !important;\n    font-weight: 700 !important;\n    line-height: normal !important;\n    transition: all 0.2s;\n}\n\n.btn-modal-outline:hover {\n    background-color: #f8f9fa !important;\n}\n\n.btn-modal-solid {\n    background-color: #000 !important;\n    color: #fff !important;\n    border: 1px solid #000 !important;\n    border-radius: 12px;\n    font-family: 'Montserrat', sans-serif !important;\n    font-size: 15px !important;\n    font-weight: 700 !important;\n    line-height: normal !important;\n    transition: all 0.2s;\n}\n\n.btn-modal-solid:hover {\n    background-color: #212529 !important;\n}\n\n/* ======================================\n   RESPONSIVE WILDCARD (SEARCH & FILTERS)\n   ====================================== */\n\n.filter-bar-container-desktop {\n  display: block !important;\n}\n\n.search-filter-inner-flex {\n  gap: 70px;\n}\n\n@media (max-width: 991px) {\n  /* Tablet / iPad Portrait */\n  .search-filter-inner-flex {\n    flex-wrap: nowrap !important;\n    gap: 10px !important;\n  }\n  .search-container {\n    flex: 1 1 auto !important;\n    width: auto !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .action-buttons-container {\n    flex: 0 0 auto !important;\n    justify-content: flex-end !important;\n  }\n}\n\n@media (max-width: 575px) {\n  /* Mobile Phones */\n  .search-filter-inner-flex {\n    flex-wrap: nowrap !important;\n    gap: 26px !important;\n  }\n  .search-container {\n    flex: 1 1 auto !important;\n    width: auto !important;\n    padding: 10px 16px !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .action-buttons-container {\n    flex: 0 0 auto !important;\n    justify-content: flex-end !important;\n    width: auto !important;\n    gap: 16px !important;\n  }\n  \n  /* Make the filter button square */\n  .action-buttons-container button.filters-btn-responsive {\n    flex: 0 0 44px !important;\n    width: 44px !important;\n    min-width: 44px !important;\n    padding: 0 !important;\n  }\n  \n  /* Mantain sizes of reset icons and favorites */\n  .action-buttons-container button.reset-icons-btn,\n  .action-buttons-container button.btn-favorites {\n    flex: 0 0 44px !important;\n    width: 44px !important;\n    min-width: 44px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
